import { styled } from 'styled-components'
import { COLORS } from 'consts/colors'

export const MyProjectsBlock = styled.div`
  border-bottom: 1px solid ${COLORS.border};
  box-sizing: border-box;
`
